import { jsx as _jsx } from "react/jsx-runtime";
import { Sorting } from "@elastic/react-search-ui";
import { injectIntl } from "react-intl";
import { SortDirectionEnum } from "../../../models/dataModel";
export const SortBy = injectIntl(({ intl }) => {
    return (_jsx(Sorting, { "data-testid": "sortBy", "aria-label": "Sort by", sortOptions: [
            {
                name: intl.formatMessage({ id: "sortBy.mostRelevant" }),
                value: "",
                direction: "",
            },
            {
                name: intl.formatMessage({ id: "sortBy.title" }),
                value: "title",
                direction: SortDirectionEnum.ASCENDING,
            },
        ] }));
});
